<template>
  <div style="margin: 0 56px 16px;">
<!--    <div style="background-color: #f6f6f6; padding: 8px 16px; border-radius: 8px; display: flex; justify-content: space-between; margin-bottom: 24px;">-->
<!--      <div><label>超级管理员：</label><el-switch v-model="isSuper" /></div>-->
<!--      <div><label>停用账号：</label><el-switch v-model="state" /></div>-->
<!--    </div>-->
    <el-form ref="formRef" :model="userForm" label-width="90px" label-position="right">
      <el-form-item label="用户类型：">
        <el-radio-group v-model="loginState" class="ml-4" :disabled="loginPositionType >= 2 && idx == -1" @change="stateChange">
          <el-radio :label="0">可登录</el-radio>
          <el-radio :label="1">不可登录（仅用于业绩统计）</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="账号：" v-show="loginState == 0">
        <el-input v-model="userForm.account" placeholder="请输入账号" />
      </el-form-item>
      <el-form-item label="密码：" v-show="loginState == 0">
        <el-input v-model="pwd" placeholder="请输入密码" />
      </el-form-item>
      <el-form-item label="手机：" v-show="loginState == 0">
        <el-input v-model="userForm.phone" placeholder="请输入手机号" maxlength="11"/>
      </el-form-item>
      <el-form-item label="名称：">
        <el-input v-model="userForm.name" placeholder="请输入姓名" />
      </el-form-item>
      <el-form-item label="角色名称：" v-if="userForm.account != 'root'">
        <el-select v-model="sysRoleId" placeholder="Select" style="width: 8em" @change="sysRoleChange">
          <el-option v-for="item in sysRoleIdArray" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="可见时间：" v-show="loginState == 0">
        <el-select v-model="duration" value-key="value" placeholder="请选择"  style="width: 8em;">
          <el-option v-for="item in durationList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属门店：">
        <div style="border: 1px solid #dcdfe6; border-radius: 4px; padding: 12px 16px; width: 100%">
          <div style="border-bottom: 1px solid #ededed; padding-bottom: 4px;margin-bottom: 8px;width: 100%; display: flex; align-items: center; justify-content: space-between">
            <el-checkbox style="width: 8.5em; margin: 0 8px;" v-model="checkAll" label="全部" @change="checkAllChange"/>
            <el-switch size="small" v-model="editAll" style="scale: 0.8" @change="editAllChange"></el-switch>
          </div>
<!--          <el-checkbox-group v-model="ownShopIdArr" @change="ownChange">-->
<!--          <el-scrollbar height="300px" style="margin-top: 8px;">-->
          <div v-for="(item,i) of allShopArr" :key="item.id"  style="width: 100%; display: flex; justify-content: space-between">
            <el-checkbox style="width: 8.5em; margin: 0 8px;"  v-model="item.check" :label="item.name" @change="itemChange($event,i)"/>
            <div style="font-size: 12px; display: flex; align-items: center">
              可编辑：<el-switch size="small" v-model="item.edit" style="scale: 0.8" @change="editChange($event,i)"></el-switch>
            </div>
          </div>
<!--          </el-scrollbar>-->


<!--          </el-checkbox-group>-->
        </div>
      </el-form-item>
<!--      <el-form-item label="编辑门店：">-->
<!--        <div style="border: 1px solid #dcdfe6; border-radius: 4px; padding: 12px 16px;">-->
<!--          <div><el-checkbox style="width: 8.5em; margin: 0 8px;" v-model="checkAllVisible" label="全部" @change="checkAllVisibleChange"/></div>-->
<!--&lt;!&ndash;          <el-checkbox-group v-model="visibleShopIdArr" @change="visibleChange">&ndash;&gt;-->
<!--            <el-checkbox style="width: 8.5em; margin: 0 8px;" v-for="item of shopIdArr" :key="item.id" :label="item.id" >{{item.name}}</el-checkbox>-->
<!--&lt;!&ndash;          </el-checkbox-group>&ndash;&gt;-->
<!--        </div>-->
<!--      </el-form-item>-->
      <el-form-item label="离职时间：">
        <el-date-picker
            v-model="userForm.dismissionDate"
            type="date"
            placeholder="请选择出生日期"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            style="width: 100%"
        />
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import {postFormData, getFormData, postJson} from "@/api/api"
import { addOrUpdateUser, listSysRoleSelect, getAllShopList } from "@/api/url";

export default {
name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
   return {
     userForm: this.value.userForm,
     idx: this.value.ids,
     pwd: '',
     isSuper: this.value.userForm.isSuper == 1?true: false,
     state: this.value.userForm.state == 1?true:false,

     positionTypeArray: [],
     positionType: this.value.userForm.positionType?this.value.userForm.positionType:'',

     sysRoleIdArray: [],
     sysRoleId: this.value.userForm.sysRoleId?this.value.userForm.sysRoleId:'',

     shopIdArr: this.value.shopIdArr,
     allShopArr: [],
     ownShopIdArr: [],
     visibleShopIdArr: [],
     checkAll: false,
     editAll: false,
     checkAllOwn: false,
     checkAllVisible: false,

     durationList: [
       {label: '不限', value: 0},
       {label: '1个月', value: 1},
       {label: '2个月', value: 2},
       {label: '3个月', value: 3},
       {label: '6个月', value: 6},
       {label: '1年', value: 12},
       {label: '2年', value: 24},
     ],
     duration: this.value.userForm.duration?this.value.userForm.duration:0,

     loginState: this.value.userForm.loginState?this.value.userForm.loginState:0,
     loginPositionType: '',

     allShopList: [],

   }
  },
  methods: {

    checkAllChange(val) {
      if(val) {
        this.editAll = true
        this.allShopArr.map(item => {
          item.check = true
          item.edit = true
        })
      }else {
        this.editAll = false
        this.allShopArr.map(item => {
          item.check = false
          item.edit = false
        })
      }
    },

    editAllChange(val) {
      if(val) {
        this.checkAll = true
        this.allShopArr.map(item => {
          item.check = true
          item.edit = true
        })
      }else {
        this.allShopArr.map(item => {
          item.edit = false
        })
      }
    },

    itemChange(val, idx) {
      // console.log(val)
      this.allShopArr[idx].check = val
      this.allShopArr[idx].edit = val
      if(this.allShopArr.some(function (item) {return item.check == false})) {
        this.checkAll = false
        this.editAll = false
      }else {
        this.checkAll = true
      }
    },

    editChange(val, idx) {
      // console.log(val)
      if(val) {
        this.allShopArr[idx].check = val
        this.allShopArr[idx].edit = val
      }else {
        this.allShopArr[idx].edit = val
      }
      if(this.allShopArr.some(function (item) {return item.edit == false})) {
        this.editAll = false
      }else {
        this.editAll = true
        this.checkAll = true
      }
    },

    cancel() {
      this.$emit("close");
    },

    stateChange() {
      if(this.loginState == 1) {
        this.userForm.account = ''
        this.pwd = ''
        this.userForm.phone = ''
        this.duration = 0
      }
    },

    summit() {
      console.log(this.idx)
      if(!this.userForm.account && this.loginState == 0) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '账号不能为空',
          type: 'warning'
        });
        return false
      }
      if(this.idx == -1 && !this.pwd && this.loginState == 0) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '密码不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.userForm.phone && this.loginState == 0) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '手机号不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.userForm.name) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '名称不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.sysRoleId && this.userForm.account != "root") {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请选择角色名称',
          type: 'warning'
        });
        return false
      }
      if(this.allShopArr.every(function (item) {return item.check == false})) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '所属门店不能为空',
          type: 'warning'
        });
        return false
      }
      let adminShopList = []
      this.allShopArr.map(item => {
        let obj = {}
        if(item.check) {
          obj.shopId = item.id
          if(item.edit) {
            obj.isEdit = 1
          }else {
            obj.isEdit = 0
          }
          adminShopList.push(obj)
        }
      })
      let param = {}

      param['id'] = this.idx > -1?this.userForm.id:0;
      param['loginState'] = this.loginState;
      if(this.userForm.account == 'root') {
        param['sysRoleId'] = 0;
      }else {
        param['sysRoleId'] = this.sysRoleId;
      }
      param['account'] = this.userForm.account;
      param['dismissionDate'] = this.userForm.dismissionDate;
      param['pwd'] = this.pwd;
      param['phone'] = this.userForm.phone;
      param['name'] = this.userForm.name;
      param['positionType'] = this.positionType;
      param['duration'] = !this.isSuper?this.duration:0;
      param['isSuper'] = this.isSuper?1:0;
      param['state'] = this.state?1:0;
      param['adminShopList'] = adminShopList
      param['ownShopState'] = this.checkAll && this.editAll?2:this.checkAll && !this.editAll?1:0
      postJson(addOrUpdateUser, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

    sysRoleChange() {
      this.sysRoleIdArray.map(item => {
        if(item.id == this.sysRoleId) {
          this.positionType = item.positionType
        }
      })
    },

    getPositionList() {
      getFormData(listSysRoleSelect).then(data=> {
        this.sysRoleIdArray = data.data
        if(this.idx == -1) {
          this.sysRoleId = this.sysRoleIdArray[0].id
          this.positionType = this.sysRoleIdArray[0].positionType
        }
      })
    },


    getShopList() {
      getFormData(getAllShopList).then(data=> {
        this.allShopArr = data.data.filter(item => item.id != 0)
        this.allShopArr.map(item => {
          item.check = false
          item.edit = false
        })
        if(this.idx > -1) {
          this.listCheck()
        }
      })
    },

    //初始化选项
    listCheck() {
      for(let i=0; i<this.userForm.ownShopList.length; i++) {
        for(let j=0; j<this.allShopArr.length; j++) {
          if(this.userForm.ownShopList[i].id == this.allShopArr[j].id) {
            this.allShopArr[j].check = true
            if(this.userForm.ownShopList[i].isEdit == 1) {
              this.allShopArr[j].edit = true
            }
          }
        }
      }
      if(this.allShopArr.every(item => item.check == true)) {
        this.checkAll = true
      }
      if(this.allShopArr.every(item => item.edit == true)) {
        this.editAll = true
      }
    }


  },
  mounted() {
    this.getPositionList()
    if(JSON.parse(sessionStorage.getItem('isSuper')) == 1) {
      this.getShopList()
    }else {
      this.allShopArr = []
      this.shopIdArr.map(item => {
        item.check = false
        item.edit = false
      })
      this.allShopArr = this.allShopArr.concat(this.shopIdArr)
      if(this.idx > -1) {
        this.listCheck()
      }
    }


    if(this.idx == -1) {
      this.loginPositionType = JSON.parse(sessionStorage.getItem('positionType'))
      if(this.loginPositionType == 2) {
        this.loginState = 1
      }
    }
  }
}
</script>

<style scoped>

</style>
